/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEaseInFilled: {
  name: 'ease-in-filled';
  data: string;
} = {
  name: 'ease-in-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.486 2.598c-.469.173-.622.352-1.129 1.322-1.585 3.028-3.528 6.049-5.378 8.36-2.142 2.677-4.245 4.548-6.159 5.481-1.005.49-1.621.653-2.848.754-.494.04-.757.156-1.045.462-.314.333-.387.527-.387 1.023 0 .385.01.439.117.651.139.273.445.575.723.711.189.093.238.098.88.096.777-.001 1.322-.082 2.122-.313 2.727-.786 5.605-2.966 8.481-6.425 2.061-2.478 4.256-5.827 6.068-9.26.519-.985.565-1.116.54-1.551-.032-.557-.323-.997-.831-1.256-.295-.15-.827-.176-1.154-.055"/></svg>`
};
